import { render, staticRenderFns } from "./ProductSizeDialog.vue?vue&type=template&id=24d4d8ca&scoped=true&"
import script from "./ProductSizeDialog.vue?vue&type=script&lang=js&"
export * from "./ProductSizeDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProductSizeDialog.vue?vue&type=style&index=0&id=24d4d8ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d4d8ca",
  null
  
)

export default component.exports